import React, { Component, Fragment } from 'react'
import {Helmet} from "react-helmet";
import Breadcrumb from "../common/breadcrumb";
import RefreshIcon from "../../assets/icons/refresh.svg"
import {Spin} from "antd";
import Swal from "sweetalert2";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import { Select } from "antd";
import Switch from "react-switch";
import {pageNumber} from "../../functions/functionGeneral";
import ReactPaginate from "react-paginate";
import ArrowLeft from "../../assets/icons/arrow-left.svg";
import ArrowRight from "../../assets/icons/arrow-right.svg";
import {clear_auth, set_auth} from "../../reducers/Auth";
import {connect} from "react-redux";

export class SettingsTask extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading                 : true,
            data                    : [],
            divisi                  : [],
            prosesSimpan            : false,
            perPage                 : 0,
            currentPage             : 0,
            paginate                : 10,
            filterDivisi            : "",
            pengaturan_id           : '',
            add_input_divisi        : null,
            add_p_tugas_note        : '',
            add_p_karyawan_create   : 0,
            add_p_karyawan_note     : 0,
            add_p_karyawan_image    : 0,
            add_p_karyawan_document : 0,
            input_divisi            : null,
            input_divisi_data       : '',
            p_tugas_note            : '',
            p_karyawan_create       : 1,
            p_karyawan_note         : 1,
            p_karyawan_image        : 1,
            p_karyawan_document     : 1,
            idDel                   : ''
        }
        this.loadData = this.loadData.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.updateSettingTask = this.updateSettingTask.bind(this)
        this.addSettingTask = this.addSettingTask.bind(this)
        this.handlePage = this.handlePage.bind(this)
    }

    loadData(){
        let form = {
            filterDivisi: this.state.filterDivisi,
            paginate    : this.state.paginate,
            page        : this.state.currentPage + 1
        }
        this.props.request('task/list_setting_task', form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        loaded  : true,
                        data            : response.data.data,
                        totalData       : response.data.total,
                        pageCount       : response.data.last_page,
                        totalPerpage    : response.data.to,
                        perPage         : response.data.per_page,
                    })
                }
                this.setState({
                    loading : false
                })
            })
    }

    addSettingTask() {
        this.setState({
            prosesSimpan: true,
        })
        let form = {
            add_input_divisi        : this.state.add_input_divisi,
            add_p_tugas_note        : this.state.add_p_tugas_note,
            add_p_karyawan_create   : this.state.add_p_karyawan_create,
            add_p_karyawan_note     : this.state.add_p_karyawan_note,
            add_p_karyawan_image    : this.state.add_p_karyawan_image,
            add_p_karyawan_document : this.state.add_p_karyawan_document,
        }
        this.props.request('task/add_setting_task', form, 'POST')
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title   : 'Berhasil',
                        text    : response.message,
                        icon    : 'success'
                    })
                    this.loadData()
                } else {
                    Swal.fire({
                        title   : 'Gagal',
                        text    : response.message,
                        icon    : 'warning',
                        confirmButtonText   : 'OK'
                    })
                }
                this.setState({
                    prosesSimpan            : false,
                    modalAdd                : false,
                    add_input_divisi        : [],
                    add_p_tugas_note        : '',
                    add_p_karyawan_create   : 0,
                    add_p_karyawan_note     : 0,
                    add_p_karyawan_image    : 0,
                    add_p_karyawan_document : 0
                })
            })
    }

    updateSettingTask(){
        this.setState({
            prosesSimpan : true
        })
        let form = {
            pengaturan_id       : this.state.pengaturan_id,
            input_divisi        : this.state.input_divisi,
            p_tugas_note        : this.state.p_tugas_note,
            p_karyawan_create   : this.state.p_karyawan_create,
            p_karyawan_note     : this.state.p_karyawan_note,
            p_karyawan_image    : this.state.p_karyawan_image,
            p_karyawan_document : this.state.p_karyawan_document,
        }
        this.props.request('task/update_setting_task', form, 'POST')
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title   : 'Berhasil',
                        text    : response.message,
                        icon    : 'success'
                    })
                    this.loadData()
                } else {
                    Swal.fire({
                        title   : 'Gagal',
                        text    : response.message,
                        icon    : 'warning',
                        confirmButtonText   : 'OK'
                    })
                }
                this.setState({
                    loading     : false,
                    modalEdit   : false
                })
            })
    }

    deleteSettingTask() {
        Swal.fire({
            title               : 'Pemberitahuan',
            text                : 'Anda yakin ingin menghapus pengaturan tugas ini',
            icon                : 'warning',
            confirmButtonText   : 'Ya',
            showCancelButton    : true,
            cancelButtonText    : 'Tidak'
        })
            .then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        loading : true,
                        data    : []
                    })
                    let form = {
                        pengaturan_id : this.state.idDel
                    }
                    this.props.request('task/delete_setting_task', form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title   : 'Berhasil!',
                                    text    : response.message,
                                    icon    : 'success',
                                    showConfirmButton   : false,
                                    timer   : 800,
                                })
                                this.loadData()
                            } else {
                                Swal.fire({
                                    title   : 'Gagal!',
                                    text    : response.message,
                                    icon    : 'warning',
                                    showConfirmButton   : false,
                                    timer   : 800,
                                })
                            }
                        });
                }
            })
    }

    loadDivisi() {
        this.props.request("get_divisi_perusahaan", 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        loading: false,
                        divisi: response.data
                    })
                }
            });
    }

    handlePage(data) {
        let selected = data.selected; // zero based index
        this.setState({ currentPage: selected, loading: true }, () => {
            this.loadData();
        });
    }

    handleFilter = (event) => {
        const target = event.target
        const value = target.value
        const name = target.name

        this.setState({
            [name] : value,
            loading : true,
            data : []
        }, () => this.loadData())
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }

    componentDidMount() {
        this.loadData()
        this.loadDivisi()
    }

    render() {
        const style = {
            th_style : {
                borderBottom: "0px",
                padding: "16px 12px",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px",
                color: "#252B2B",
                minWidth: "400px",
                maxWidth: "500px"
            },
            td_style : {
                padding: "16px 12px",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "24px",
                color: "#252B2B",
                minWidth: "30px",
                maxWidth: "200px"
            },
            style_name : {
                fontWeight: 700,
                fontSize: "14px",
                color: "#252B2B",
                lineHeight: "24px"
            },
            font_header: {
                "fontWeight": 700,
                "fontSize": "18px",
                "lineHeight": "27px",
                "color": "#143B5E"
            },
        }
        const { Option } = Select;
        let no = 0;
        if (this.props.user.user_level.level_page_limited === null || this.props.user.user_level.level_page_limited.search("Tugas") >= 0) {
            return(
                <Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Pengaturan Tugas - Presensi</title>
                        <meta name="description" content="Setting Tugas" />
                    </Helmet>
                    <Breadcrumb title="Pengaturan Tugas" parent="Tugas" />
                    <Modal style={{marginRight: '10px', width: '420px'}}
                           isOpen={this.state.modalAdd}
                           toggle={() => {this.setState({
                               modalAdd                 : false,
                               add_input_divisi         : [],
                               add_p_tugas_note         : '',
                               add_p_karyawan_create    : 0,
                               add_p_karyawan_note      : 0,
                               add_p_karyawan_image     : 0,
                               add_p_karyawan_document  : 0
                           })}}>
                        <ModalHeader className='pl-4 border-bottom-0'>
                            <div style={style.font_header}>Tambah Pengaturan Tugas</div>
                        </ModalHeader>
                        <ModalBody>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <Select
                                        name="add_input_divisi"
                                        style={{ width: '100%' }}
                                        value={this.state.add_input_divisi}
                                        mode={"multiple"}
                                        placeholder="Pilih Divisi"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                            option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        onChange={(event) => {
                                            if (event.includes(null)) {
                                                this.setState({
                                                    add_input_divisi: null,
                                                });
                                            } else {
                                                this.setState({
                                                    add_input_divisi: event,
                                                });
                                            }
                                        }}
                                    >
                                        <Option key="semua divisi" value={null}>
                                            Semua Divisi
                                        </Option>
                                        {this.state.add_input_divisi !== null &&
                                            this.state.divisi.map((item) => (
                                                <Option key={item.divisi_id} value={item.divisi_id}>
                                                    {item.divisi_name}
                                                </Option>
                                            ))}
                                    </Select>
                                </div>
                                <div className="input-group mb-3">
                                    <label>
                                        Pengaturan Tugas Note
                                    </label>
                                    <input name="add_p_tugas_note" className="form-control input-basic"
                                           placeholder="Catatan Tugas ..."
                                           type="text" onChange={this.handleChange}/>
                                </div>
                                <div className="row mb-3">
                                    <label className='form-label label-input-basic col-md-10 col-sm-6 mt-4'>
                                        Pengaturan Karyawan Create
                                    </label>
                                    <Switch
                                        id={'add_p_karyawan_create'}
                                        name="add_p_karyawan_create"
                                        checked={
                                            this.state.add_p_karyawan_create === '1' ? true : false
                                        }
                                        onChange={(val) => {
                                            this.setState({
                                                add_p_karyawan_create: val ? '1' : '0'
                                            })
                                        }}
                                        onColor="#1890ff"
                                        offColor="#eb4034"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={24}
                                        width={48}
                                        className="mr-1 switch-settings-app mt-4"
                                    />
                                </div>
                                <div className="row mb-3">
                                    <label className='form-label label-input-basic col-md-10 col-sm-6'>
                                        Pengaturan Karyawan Note
                                    </label>
                                    <Switch
                                        id={'add_p_karyawan_note'}
                                        name="add_p_karyawan_note"
                                        checked={
                                            this.state.add_p_karyawan_note === '1' ? true : false
                                        }
                                        onChange={(val) => {
                                            this.setState({
                                                add_p_karyawan_note: val ? '1' : '0'
                                            })
                                        }}
                                        onColor="#1890ff"
                                        offColor="#eb4034"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={24}
                                        width={48}
                                        className="mr-1 switch-settings-app"
                                    />
                                </div>
                                <div className="row mb-3">
                                    <label className='form-label label-input-basic col-md-10 col-sm-6'>
                                        Pengaturan Karyawan Image
                                    </label>
                                    <Switch
                                        id={`add_p_karyawan_image`}
                                        name="add_p_karyawan_image"
                                        checked={
                                            this.state.add_p_karyawan_image === '1' ? true : false
                                        }
                                        onChange={(val) => {
                                            this.setState({
                                                add_p_karyawan_image: val ? '1' : '0'
                                            })
                                        }}
                                        onColor="#1890ff"
                                        offColor="#eb4034"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={24}
                                        width={48}
                                        className="mr-1 switch-settings-app"
                                    />
                                </div>
                                <div className="row">
                                    <label className='form-label label-input-basic col-md-10 col-sm-6'>
                                        Pengaturan Karyawan Document
                                    </label>
                                    <Switch
                                        id={'add_p_karyawan_document'}
                                        name="add_p_karyawan_document"
                                        checked={
                                            this.state.add_p_karyawan_document === '1' ? true : false
                                        }
                                        onChange={(val) => {
                                            this.setState({
                                                add_p_karyawan_document: val ? '1' : '0'
                                            })
                                        }}
                                        onColor="#1890ff"
                                        offColor="#eb4034"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={24}
                                        width={48}
                                        className="mr-1 switch-settings-app"
                                    />
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <div className='row mx-0' style={{width: "100%"}}>
                                <div className='col-md-6 px-1'>
                                    <button className='izin-tolak-button' style={{width: "100%"}} onClick={() => {
                                        this.setState({
                                            modalAdd: false
                                        })
                                    }}>
                                        Batal
                                    </button>
                                </div>
                                <div className='col-md-6 px-1'>
                                    <button className='btn btn-primary text-capitalize'
                                            style={{
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                lineHeight: "24px",
                                                width: "100%"
                                            }}
                                            onClick={this.addSettingTask}>
                                        Simpan
                                    </button>
                                </div>
                            </div>
                        </ModalFooter>
                    </Modal>
                    <Modal style={{width: '420px', marginRight: '10px', height: '1000px'}}
                           isOpen={this.state.modalEdit}
                           toggle={() => {
                               this.setState({modalEdit: false})
                           }}>
                        <ModalHeader>
                            <div style={style.font_header}>
                                Edit Pengaturan Tugas
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <Select
                                        name="input_divisi"
                                        style={{ width: '100%' }}
                                        value={this.state.input_divisi}
                                        mode={"multiple"}
                                        placeholder="Pilih Divisi"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                            option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        onChange={(event) => {
                                            if (event.includes(null)) {
                                                this.setState({
                                                    input_divisi: null,
                                                });
                                            } else {
                                                this.setState({
                                                    input_divisi: event,
                                                });
                                            }
                                        }}
                                    >
                                        <Option key="semua divisi" value={null}>
                                            Semua Divisi
                                        </Option>
                                        {this.state.input_divisi !== null &&
                                            this.state.divisi.map((item) => (
                                                <Option key={item.divisi_id} value={item.divisi_id.toString()}>
                                                    {item.divisi_name}
                                                </Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                                <div className="input-group mb-3">
                                    <label>
                                        Pengaturan Tugas Note
                                    </label>
                                    <input className="form-control input-basic"
                                           type="text" name="p_tugas_note"
                                           onChange={(e) => this.handleChange(e)}
                                           defaultValue={this.state.p_tugas_note}
                                           placeholder='Catatan Tugas ...'/>
                                </div>
                                <div className="row mb-3">
                                    <label className='form-label label-input-basic col-md-10 col-sm-6 mt-4'>
                                        Pengaturan Karyawan Create
                                    </label>
                                    <Switch
                                        id={'p_karyawan_create'}
                                        name="p_karyawan_create"
                                        checked={
                                            this.state.p_karyawan_create === '1' ? true : false
                                        }
                                        value={this.state.p_karyawan_create}
                                        onChange={(val) => {
                                            this.setState({
                                                p_karyawan_create: val ? "1" : "0"
                                            })
                                        }}
                                        onColor="#1890ff"
                                        offColor="#eb4034"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={24}
                                        width={48}
                                        className="mr-1 switch-settings-app mt-4"
                                    />
                                </div>
                                <div className="row mb-3">
                                    <label className='form-label label-input-basic col-md-10 col-sm-6'>
                                        Pengaturan Karyawan Note
                                    </label>
                                    <Switch
                                        id={'p_karyawan_note'}
                                        name="p_karyawan_note"
                                        checked={
                                            this.state.p_karyawan_note === '1' ? true : false
                                        }
                                        onChange={(val) => {
                                            this.setState({
                                                p_karyawan_note: val ? '1' : '0'
                                            })
                                        }}
                                        onColor="#1890ff"
                                        offColor="#eb4034"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={24}
                                        width={48}
                                        className="mr-1 switch-settings-app"
                                    />
                                </div>
                                <div className="row mb-3">
                                    <label className='form-label label-input-basic col-md-10 col-sm-6'>
                                        Pengaturan Karyawan Image
                                    </label>
                                    <Switch
                                        id={'p_karyawan_image'}
                                        name="p_karyawan_image"
                                        checked={
                                            this.state.p_karyawan_image === '1' ? true : false
                                        }
                                        onChange={(val) => {
                                            this.setState({
                                                p_karyawan_image: val ? '1' : '0'
                                            })
                                        }}
                                        onColor="#1890ff"
                                        offColor="#eb4034"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={24}
                                        width={48}
                                        className="mr-1 switch-settings-app"
                                    />
                                </div>
                                <div className="row mb-3">
                                    <label className='form-label label-input-basic col-md-10 col-sm-6'>
                                        Pengaturan Karyawan document
                                    </label>
                                    <Switch
                                        id={'p_karyawan_document'}
                                        name="p_karyawan_document"
                                        checked={
                                            this.state.p_karyawan_document === '1' ? true : false
                                        }
                                        onChange={(val) => {
                                            this.setState({
                                                p_karyawan_document: val ? '1' : '0'
                                            })
                                        }}
                                        onColor="#1890ff"
                                        offColor="#eb4034"
                                        handleDiameter={18}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                        height={24}
                                        width={48}
                                        className="mr-1 switch-settings-app"
                                    />
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <div className='row mx-0' style={{width: "100%"}}>
                                <div className='col-md-6 px-1'>
                                    <button className='izin-tolak-button' style={{width: "100%"}} onClick={() => {
                                        this.setState({
                                            modalEdit: false
                                        })
                                    }}>
                                        Batal
                                    </button>
                                </div>
                                <div className='col-md-6 px-1'>
                                    <button className='btn btn-primary text-capitalize' style={{
                                        fontSize: "14px",
                                        fontWeight: 500,
                                        lineHeight: "24px",
                                        width: "100%"
                                    }} onClick={this.updateSettingTask}>
                                        Simpan
                                    </button>
                                </div>
                            </div>
                        </ModalFooter>
                    </Modal>
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="d-flex flex-row flex-nowrap">
                                            <div className="col-md-10 mr-2 px-0 d-flex flex-nowrap karyawan-filter">
                                                <select name="filterDivisi"
                                                        className="form-control karyawan-filter-jabatan mr-1"
                                                        onChange={this.handleFilter}>
                                                    <option value="" selected={this.state.filterDivisi === ''}>Pilih
                                                        Divisi
                                                    </option>
                                                    {this.state.divisi.map((item, index) => {
                                                        return (
                                                            <option
                                                                value={item.divisi_id}>{item.divisi_name}
                                                            </option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                            <div className="pengumuman-button-refresh mb-2 mb-md-0" onClick={
                                                () => {
                                                    this.setState({
                                                        filterDivisi: "",
                                                        loading : true
                                                    }, () => this.loadData())
                                                }}>
                                                <img alt="" src={RefreshIcon}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 float-right">
                                        <button className="btn btn-primary tambah-term" style={{padding: '12px'}}
                                                onClick={() => this.setState({modalAdd: true})}>Tambah Pengaturan Tugas
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div>
                                            <div className="table-responsive">
                                                <table className="table table-striped table-borderless">
                                                    <thead>
                                                    <tr>
                                                        <th style={style.td_style}>#</th>
                                                        <th style={style.th_style}>Divisi</th>
                                                        <th style={style.td_style}>Aksi</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.state.loading ?
                                                        <tr>
                                                            <td colSpan={10}>
                                                                <Spin size="large" tip="Loading..." style={{
                                                                    width: '100%',
                                                                    margin: 'auto',
                                                                    marginBottom: '10px',
                                                                    marginTop: '10px'
                                                                }}/>
                                                            </td>
                                                        </tr>
                                                        :
                                                        this.state.data.map((item, index) => {
                                                            no += 1
                                                            return (
                                                                <tr>
                                                                    <td style={style.td_style}>
                                                                        <div>{pageNumber(no, this.state.perPage, this.state.currentPage)}</div>
                                                                    </td>
                                                                    <td style={style.style_name} align="left">{item.divisi.length > 0 ? item.divisi.map((item2, index2) => {
                                                                        return (<span>Pengaturan Divisi {item2.divisi_name}{item.divisi.length > (index2 + 1) && ", "}</span>)
                                                                    }) : (<div>Pengaturan Semua divisi</div>)}
                                                                    </td>
                                                                    <td style={style.td_style}>
                                                                        <a className="btn btn-outline-custom"
                                                                           onClick={() => {
                                                                               this.setState({
                                                                                   modalEdit: true,
                                                                                   pengaturan_id        : item.pengaturan_id,
                                                                                   input_divisi         : item.divisi_id,
                                                                                   p_tugas_note         : item.pengaturan_tugas_note,
                                                                                   p_karyawan_create    : item.pengaturan_karyawan_create,
                                                                                   p_karyawan_note      : item.pengaturan_karyawan_note,
                                                                                   p_karyawan_image     : item.pengaturan_karyawan_image,
                                                                                   p_karyawan_document  : item.pengaturan_karyawan_document,
                                                                               })
                                                                           }}>Edit</a>
                                                                        <a className="btn btn-danger-custom"
                                                                           onClick={() => {
                                                                               this.setState({
                                                                                   idDel    : item.pengaturan_id
                                                                               })
                                                                               this.deleteSettingTask()
                                                                           }}>Hapus</a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className='row mx-0' style={{ backgroundColor: "#F5F5F5", width: "100%" }}>
                                    {this.state.data.length !== 0 &&
                                        <>
                                            <div className='col font-14' style={{ padding: "auto", margin: "auto", fontWeight: 500, lineHeight: "24px" }}>Menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} dari {this.state.totalData} data</div>
                                            <div className='col'>
                                                <ReactPaginate
                                                    previousLabel={<img src={ArrowLeft} alt='' />}
                                                    nextLabel={<img src={ArrowRight} alt='' />}
                                                    pageCount={this.state.pageCount}
                                                    forcePage={this.state.currentPage}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={3}
                                                    onPageChange={this.handlePage}
                                                    breakClassName={'page-item'}
                                                    breakLinkClassName={'page-link custom-page-link'}
                                                    containerClassName={'pagination my-2'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link custom-page-link'}
                                                    previousClassName={'page-item'}
                                                    previousLinkClassName={'page-link custom-prev-next-link'}
                                                    nextClassName={'page-item'}
                                                    nextLinkClassName={'page-link custom-prev-next-link'}
                                                    activeClassName={'active custom-active'}
                                                />
                                            </div>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <h5 className="text-center pt-4">Anda tidak punya akses ke halaman ini.</h5>
                </Fragment>
            )
        }
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTask);